var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPasswordVisibilityOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.92,
    height: 11.46,
    viewBox: "0 0 22.92 11.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15071",
    "data-name": "Path 15071",
    d: "M159.86,179.2c-6.328,0-11.46,5.73-11.46,5.73s5.132,5.73,11.46,5.73,11.46-5.73,11.46-5.73-5.131-5.73-11.46-5.73Zm0,8.595a2.865,2.865,0,1,1,2.865-2.865A2.865,2.865,0,0,1,159.86,187.795Z",
    transform: "translate(-148.4 -179.2)",
    fill: "#072f33"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordVisibilityOn);
export default __webpack_public_path__ + "static/media/Password_Visibility_On.8f6252fc1e8169529d637dfa25926014.svg";
export { ForwardRef as ReactComponent };